export default __webpack_public_path__ + "static/media/icon_video_gallery.ff258ea8.svg";